// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"63":"cf03d729ee12b849","6014":"b460edb6c4a56e9e"}[chunkId] + ".css";
};